import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Constant } from '../../shared/constant';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' })

};

@Injectable({
  providedIn: 'root'
})
export class StaticContentService {

  constructor(private http: HttpClient) { }
  staticContentAPIURL = '';

  GetStaticContentDetails(entrykey: string, IsLMSLaunch: boolean) {
    if (!IsLMSLaunch){
      this.staticContentAPIURL = Constant.BaseAPIURL + 'GetEntryURLData?EntryKey=';
      return this.http.get(this.staticContentAPIURL + entrykey, httpOptions).pipe(
        map(result => {
          return result;
        }),
        catchError(this.handleError)
      );
    }
    else {
      this.staticContentAPIURL = Constant.BaseAPIURL + 'launch/launchConfig?token=';
      return this.http.get(this.staticContentAPIURL + entrykey, httpOptions).pipe(
        map(result => {
          return result;
        }),
        catchError(this.handleError)
      );
    }
  }
  HeartBeat(LearningSessionDetailID: number) {
    this.staticContentAPIURL = Constant.BaseAPIURL + 'SaveStatus?LearningSessionDetailID=' + LearningSessionDetailID;
    return this.http.get(this.staticContentAPIURL, httpOptions).pipe(
      map(result => {
        return result;
      }),
      catchError(this.handleError)
    );
  }

   private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    }
    else {
      // The backend returned an unsuccessful response code. The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError(error);
  }

}
